(function () {
  'use strict';
  angular.module('vcreminder')
    .component('clientreminder', {
      restrict: 'E',
      bindings: {
        clientid: '<',
        mode: '<?'
      },
      templateUrl: 'vcreminder/clientreminder-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Reminder', 'ClientHelper', 'Clientlog', 'vertxEventBusService',
        function ($log, $http, Rlog, Reminder, ClientHelper, Clientlog, vertxEventBusService) {

          let vm = this;

          vm.addTodoEntry = addTodoEntry;
          vm.calcdue = calcdue;
          vm.save = save;

          vm.$onInit = function () {
            vm.newreminder = {};

            let query = {
              query: {
                $and: [
                  {$or: [{clientid: vm.clientid}, {patientid: vm.clientid}]},
                  {$or: [{done: false}, {completed: {$gt: moment().subtract(3, 'days').toISOString()}}]}
                ]
              }
            };

            if (angular.isUndefined(vm.mode) || vm.mode !== 'patient') {
              vm.mode = 'client';
              query = {
                query: {
                  clientid: vm.clientid,
                  $or: [{done: false}, {completed: {$gt: moment().subtract(3, 'days').toISOString()}}]
                }
              };
            }

            if (angular.isDefined(vm.clientid)) {
              Reminder.$search(query).$then(function (reminders) {
                vm.reminders = reminders;
              }, function (err) {
                $log.error('### reminders not found, id: ', vm.clientid, vm.mode, vm.query);
                Rlog.error('reminder', 'clientreminder', 'reminder search failed', {clientid: vm.clientid});
              });

              ClientHelper.find(vm.mode, vm.clientid).$then(function (client) {
                vm.client = client;
              }, function (err) {
                $log.error('### reminders -> client nor found, clientid, mode: ', vm.clientid, vm.mode, err);
                Rlog.error('reminder', 'clientreminder', 'patient search failed', {clientid: vm.clientid});
              });
            }
          };

          function addTodoEntry() {
            vm.newreminder.done = false;
            if (angular.isDefined(vm.client.primarycontact.firstname) && angular.isDefined(vm.client.primarycontact.lastname)) {
              vm.newreminder.pfname = vm.client.primarycontact.firstname;
              vm.newreminder.plname = vm.client.primarycontact.lastname;
            }
            if (angular.isDefined(vm.client.svdata.svnr)) {
              vm.newreminder.psvnr = vm.client.svdata.svnr;
            } else if (angular.isDefined(vm.client.svdata.bdateat)) {
              vm.newreminder.pbdateat = vm.client.svdata.bdateat;
            }
            vm.newreminder.clientid = vm.clientid;
            if (!vm.newreminder.due) {
              vm.newreminder.due = moment().toISOString();
              vm.newreminder.duestr = 'Sofort';
            }

            Reminder.$create(vm.newreminder).$then(function (rem) {
              let logentry = {};
              logentry.created = moment().toISOString();
              logentry.clientid = vm.clientid;
              logentry.patientid = vm.clientid;
              logentry.entry = 'Todo erstellt: ' + rem.label;
              Clientlog.$create(logentry);

            }, function (err) {
              $log.error('reminders not created, id: ', vm.clientid, err);
              Rlog.error('reminder', 'clientreminder', 'reminder creation failed', {clientid: vm.clientid});
            });
            vm.newreminder = {};
          }

          function calcdue(days, str) {
            vm.newreminder.due = moment().add(days, 'days').toISOString();
            vm.newreminder.duestr = str;
          }

          function save(item) {

            let logentry = {};
            logentry.created = moment().toISOString();
            logentry.clientid = vm.clientid;
            logentry.patientid = vm.clientid;
            if (item.done === true) {
              item.completed = moment().toISOString();
              logentry.entry = 'Todo abgeschlossen: ' + item.label;
            }
            if (item.done === false) {
              delete item.completed;
              logentry.entry = 'Todo wieder geöffnet: ' + item.label;
            }

            if (item.$hasPendingActions()) {
              item.$cancel();
            }
            item.$save().$then(function () {
              Clientlog.$create(logentry);
            }, function (err) {
              $log.error('reminders state could not be changed: ', item);
              Rlog.error('reminder', 'clientreminder', 'reminder status change failed', {
                reminderid: item._id,
                clientid: vm.clientid
              });
            });
          }

          const remindersUpdateHandler = function (message) {
            let messages = message.split(':');
            $log.debug('Reminders updated: ', message);
            if (angular.isDefined(vm.reminders)){
              vm.reminders.$refresh();
            }
          };


          // listen for reminder updates
          vertxEventBusService.on('reminders.update', remindersUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('reminders.update', {}, remindersUpdateHandler);
          };

        }] // controller
    }); // component

  // klammerfriedhof
}());
